var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.917,
    height: 18.452,
    viewBox: "0 0 12.917 18.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M13.958,3A6.454,6.454,0,0,0,7.5,9.458c0,4.844,6.458,11.994,6.458,11.994s6.458-7.15,6.458-11.994A6.454,6.454,0,0,0,13.958,3Zm0,8.765a2.307,2.307,0,1,1,2.307-2.307A2.307,2.307,0,0,1,13.958,11.765Z",
    transform: "translate(-7.5 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.badfa2c7d5b8b2d04d5c488b7cdccb7f.svg";
export { ForwardRef as ReactComponent };